import { render } from "./index.vue?vue&type=template&id=492cef3b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=492cef3b&lang=scss"
script.render = render

export default script